import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import NewsletterPageLayout from '@/components/pages/newsletter/layout/newsletter-page-layout';

export interface NewsletterPageControllerProps {}

export const NewsletterPageController = (props: NewsletterPageControllerProps) => {
    return <NewsletterPageLayout {...props} />;
};

export default withExceptionCatcher(NewsletterPageController);
